import { useClientRest } from "@shared/hooks";
import { toSnake, transformQueryParamsWithoutLocale } from "@shared/utils";
import { Ninja_Villages } from "@sisnaker-react-core/karirhub-model-type";
import { useQuery } from "@tanstack/react-query";

export function useVillages({
  keyword,
  subDistrictIds,
  page = 1,
  limit = 10,
  enabled = true,
}: {
  keyword: string;
  subDistrictIds?: string[];
  page?: number;
  limit?: number;
  enabled?: boolean;
}) {
  const { request } = useClientRest();

  const query = useQuery<{ data: Ninja_Villages[] }>({
    queryKey: ["common-villages-", keyword, (subDistrictIds || [])?.join(","), limit, page],
    queryFn: () =>
      request({
        url: transformQueryParamsWithoutLocale("/karirhub/onboarding/v2/villages", toSnake({
          keyword,
          subDistrictIds,
          limit,
          page,
        })),
        method: "GET",
        options: {
          cache: "no-store",
        },
      }),
    enabled: enabled,
  });

  const refetch = () => {
    query.refetch();
  };

  return {
    isLoading: query.isLoading,
    villages: query.data?.data || [],
    query,
    refetch,
  };
}
